import { QueryCache, QueryClient } from '@tanstack/react-query';
import { ApiRequestError } from './api-client';
/**
 * What a person is told when their session is fine and the answer is still no.
 *
 * One sentence, in one place, because the three consoles say it about different screens and a
 * second copy is how they drift. It names the situation and the remedy without guessing which
 * permission was missing — the API deliberately does not say, and a client that guessed would be
 * telling somebody what to go and ask for by name.
 */
export const NOT_AUTHORIZED_MESSAGE = "You're not authorised to do that. Ask an owner of this organization if you need access.";
export function createQueryClient(options = {}) {
    const reportForbidden = (error) => {
        if (error instanceof ApiRequestError && error.statusCode === 403) {
            options.onForbidden?.(error);
        }
    };
    return new QueryClient({
        queryCache: new QueryCache({ onError: reportForbidden }),
        defaultOptions: {
            queries: {
                staleTime: 30_000,
                refetchOnWindowFocus: false,
                retry: (failureCount, error) => {
                    if (error instanceof ApiRequestError &&
                        error.statusCode >= 400 &&
                        error.statusCode < 500) {
                        return false;
                    }
                    return failureCount < 2;
                },
            },
            mutations: {
                retry: false,
                onError: reportForbidden,
            },
        },
    });
}
//# sourceMappingURL=query-client.js.map